

































































import { Component, Prop, Vue } from "vue-property-decorator";
import FinishedAttemptModel from "@/model/FinishedAttemptModel";
import AttemptModule from "@/store/AttemptModule";
import QuestionResult from "@/components/QuestionResult.vue";
import Axios from "axios";
@Component({
  components: { QuestionResult }
})
export default class FinishedAttempt extends Vue {
  @Prop()
  attempt!: FinishedAttemptModel;

  enquirySent: boolean = false;

  retryAttempt(): void {
    AttemptModule.retryAttempt(this.attempt);
  }

  async sendEnquiry() {
    const input = document.querySelector("input[name=enquiry-email]") as HTMLInputElement;
    const email = input.value;
    console.log(email);
    await Axios.get(
        process.env.VUE_APP_API_URL + "/api/attempt/send-enquiry-email/" + AttemptModule.attemptUuid + "?email=" + email,
    );
    this.enquirySent = true;
  }

}
